var React = require('react');

function CardClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.77855 6.84019L15.6066 0L17.5571 1.95395L10.729 8.79414L17.5571 15.6343L15.6066 17.5883L8.77855 10.7481L1.95048 17.5883L0 15.6343L6.82807 8.79414L0 1.95395L1.95048 0L8.77855 6.84019Z","fill":"white"}));
}

CardClose.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = CardClose;

CardClose.default = CardClose;
